import i18next from 'i18next';
import en from './navigation-i18n/en';
import { UserType } from 'app/main/aiaas/util/consts';

i18next.addResourceBundle('en', 'navigation', en);

const navigationConfig = [
    {
        id: 'home',
        title: 'Home',
        translate: 'home',
        type: 'item',
        url: '/services',
        isPublic: true,
        target: '_blank'
    },
    {
        id: 'services',
        title: 'Services',
        translate: 'services',
        type: 'group',
        url: '/services',
        freePreUrl: '/free',
        isPublic: true,
        children: [
            {
                id: 'base-service',
                title: 'Base Services',
                translate: 'baseService',
                type: 'collapse',
                icon: 'crop_original',
                isPublic: true,
                children: [
                    {
                        id: 'line-segment-detector',
                        title: 'Line Segment Detector',
                        translate: 'lineSegmentDetector',
                        type: 'item',
                        url: '/base-service/line-segment-detector',
                        isPublic: true,
                        freePreUrl: '/free',
                    },
                    {
                        id: 'arc-line-detector',
                        title: 'ArcLine Detector',
                        translate: 'arcLineDetector',
                        type: 'item',
                        url: '/base-service/arc-line-detector',
                        isPublic: true,
                        freePreUrl: '/free',
                    },
                    {
                        id: 'contrast-enhancement',
                        title: 'Contrast Enhancement',
                        translate: 'contrastEnhancement',
                        type: 'item',
                        url: '/base-service/contrast-enhancement',
                        isPublic: true,
                        freePreUrl: '/free',
                    },
                    {
                        id: 'denoising',
                        title: 'Denoising',
                        translate: 'denoising',
                        type: 'item',
                        url: '/base-service/denoising',
                        isPublic: true,
                        freePreUrl: '/free',
                    },
                    {
                        id: 'deblurring',
                        title: 'Deblurring',
                        translate: 'deblurring',
                        type: 'item',
                        url: '/base-service/deblurring',
                        isPublic: true,
                        freePreUrl: '/free',
                    },
                    {
                        id: 'deraining',
                        title: 'Deraining',
                        translate: 'deraining',
                        type: 'item',
                        url: '/base-service/deraining',
                        isPublic: true,
                        freePreUrl: '/free',
                    },
                    {
                        id: 'resolution-enhancement',
                        title: 'Resolution Enhancement',
                        translate: 'resolutionEnhancement',
                        type: 'item',
                        url: '/base-service/resolution-enhancement',
                        isPublic: true,
                        freePreUrl: '/free',
                    },
                    {
                        id: 'inpainting',
                        title: 'Inpainting',
                        translate: 'inpainting',
                        type: 'item',
                        url: '/base-service/inpainting',
                        isPublic: true,
                        freePreUrl: '/free',
                    }
                ]
            },
            {
                id: 'detection',
                title: 'Detection',
                translate: 'detection',
                type: 'collapse',
                icon: 'find_in_page',
                isPublic: true,
                children: [
                    {
                        id: 'object-detection',
                        title: 'Object Detection',
                        translate: 'objectDetection',
                        type: 'item',
                        url: '/detection/object-detection',
                        isPublic: true,
                        freePreUrl: '/free',
                    },
                    {
                        id: 'pose-estimation',
                        title: 'Pose Estimation',
                        translate: 'poseEstimation',
                        type: 'item',
                        url: '/detection/pose-estimation',
                        isPublic: true,
                        freePreUrl: '/free',
                    },
                    {
                        id: 'face-detection',
                        title: 'Face Detection',
                        translate: 'faceDetection',
                        type: 'item',
                        url: '/detection/face-detection',
                        isPublic: true,
                        freePreUrl: '/free',
                    },
                    {
                        id: 'count-objects',
                        title: 'Count Objects',
                        translate: 'countObjects',
                        type: 'item',
                        url: '/detection/count-objects',
                        isPublic: true,
                        freePreUrl: '/free',
                    },
                    {
                        id: 'anomaly-detection',
                        title: 'Anomaly Detection',
                        translate: 'anomalyDetection',
                        type: 'item',
                        url: '/detection/anomaly-detection',
                        isPublic: true,
                        freePreUrl: '/free',
                    }
                ]
            },
            {
                id: 'authentication',
                title: 'Authentication',
                translate: 'authentication',
                type: 'collapse',
                icon: 'security',
                isPublic: true,
                children: [
                    {
                        id: 'face-recognition',
                        title: 'Face Recognition',
                        translate: 'faceRecognition',
                        type: 'item',
                        url: '/authentication/face-recognition',
                        isPublic: true,
                        freePreUrl: '/free',
                    }
                ]
            },
            {
                id: 'annotation-service',
                title: 'Annotation',
                translate: 'annotationService',
                type: 'collapse',
                icon: 'label',
                isPublic: true,
                children: [
                    {
                        id: 'boundary-annotation',
                        title: 'Boundary Annotation',
                        translate: 'boundaryAnnotation',
                        type: 'item',
                        url: '/annotation-service/boundary-annotation',
                        isPublic: true,
                        freePreUrl: '/free',
                    },
                    {
                        id: 'bounding-box-annotation',
                        title: 'Bounding Box Annotation',
                        translate: 'boundingBoxAnnotation',
                        type: 'item',
                        url: '/annotation-service/bounding-box-annotation',
                        isPublic: true,
                        freePreUrl: '/free',
                    },
                    {
                        id: 'classification-annotation',
                        title: 'Classification Annotation',
                        translate: 'classificationAnnotation',
                        type: 'item',
                        url: '/annotation-service/classification-annotation',
                        isPublic: true,
                        freePreUrl: '/free',
                    }
                ]
            },
            {
                id: 'learning',
                title: 'Learning',
                translate: 'learning',
                type: 'collapse',
                icon: 'model_training',
                isPublic: true,
                children: [
                    {
                        id: 'gpu',
                        title: 'Deep Learning',
                        translate: 'deepLearning',
                        type: 'item',
                        url: '/learning/deep-learning/job',
                        isPublic: true,
                        freePreUrl: '/free',
                    },
                ]
            },
            // {
            //     id: 'advanced',
            //     title: 'Advanced',
            //     translate: 'advanced',
            //     type: 'collapse',
            //     icon: 'upgrade',
            //     forLoggedIn: true,
            //     isPublic: true,
            //     children: [
            //         {
            //             id: 'corrective-exercise',
            //             title: 'Corrective exercise',
            //             translate: 'correctiveExercise',
            //             type: 'item',
            //             url: '/advanced-service/corrective-exercise',
            //             isPublic: false,
            //             freePreUrl: '/free',
            //         }
            //     ]
            // },
        ]
    },
    {
        id: 'pricing',
        title: 'Pricing',
        translate: 'pricing',
        type: 'group',
        url: '/pricing',
        freePreUrl: '/free',
        isPublic: true,
        children: [
            {
                id: 'pricing',
                title: 'Pricing',
                translate: 'pricing',
                type: 'item',
                icon: 'attach_money',
                url: '/pricing',
                freePreUrl: '/free',
                isPublic: true,
                // badge:{
                //     bg:'red',
                //     fg:'white',
                //     title:'Special Offers'
                // }
            }
        ]
    },
    {
        id: 'support',
        title: 'Support',
        translate: 'support',
        type: 'group',
        isPublic: true,
        children: [
            {
                id: 'faq',
                title: 'Faq',
                translate: 'faq',
                type: 'item',
                icon: 'help',
                url: '/faq',
                isPublic: true
            },
            {
                id: 'new-ticket',
                title: 'New Ticket',
                translate: 'newTicket',
                type: 'item',
                icon: 'send',
                url: '/ticket/new-ticket',
                isPublic: true,
                forLoggedIn: true,
                auth: [UserType.NORMAL, UserType.SUPPORTER, UserType.ADMIN],

            }
        ]
    },
    {
        id: 'memberSpace',
        title: 'Member Space',
        translate: 'memberSpace',
        type: 'group',
        forLoggedIn: true,
        auth: [UserType.NORMAL, UserType.SUPPORTER, UserType.ADMIN],
        isPublic: true,
        children: [
            {
                id: 'tickets',
                title: 'My Tickets',
                translate: 'tickets',
                icon: 'library_books',
                type: 'item',
                url: '/ticket/my-tickets',
                isPublic: true
            },
            {
                id: 'payment-archive',
                title: 'Payment Archive',
                translate: 'paymentArchive',
                type: 'item',
                icon: 'payments',
                url: '/payment-archive',
                isPublic: true,
                forLoggedIn: true,
            },
            {
                id: 'license-archive',
                title: 'License Archive',
                translate: 'License Archive',
                type: 'item',
                icon: 'local_police',
                url: '/license-archive',
                isPublic: true,
                forLoggedIn: true,
            },
            {
                id: 'profile',
                title: 'Profile',
                translate: 'profile',
                type: 'item',
                icon: 'person',
                url: '/profile',
                isPublic: true
            }
        ]
    }
];

export default navigationConfig;
